import { render, staticRenderFns } from "./Saluo.vue?vue&type=template&id=562f1af3&"
import script from "./Saluo.vue?vue&type=script&lang=js&"
export * from "./Saluo.vue?vue&type=script&lang=js&"
import style0 from "./Saluo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports